<template>
    <div>
        <div :class="[`cs-item cs-status-${status}`]">
            <div class="cs-status-icon">
                <span v-if="ACTIVE_STATUS === status">ON</span>
                <span v-if="EXPIRED_STATUS === status">OFF</span>
                <span v-if="REFUND_STATUS === status">REF</span>
            </div>
            <div class="cs-title">{{ $t('subscription') }}</div>
            <div class="cs-dates" v-if="ACTIVE_STATUS === status">
              Активен до {{crmSubscription.dateExpiration | formatDate}}
            </div>
            <div class="cs-dates" v-else>
              Использован до {{crmSubscription.dateExpiration | formatDate}}
            </div>
            <div class="cs-lessons" v-if="ACTIVE_STATUS === status || crmSubscription.lessonBalance === 0"><span class="cs-lbl">Занятий доступно:</span>
                <span class="cs-off-nums"> {{ crmSubscription.lessonBalance }}</span>
                <!-- <div>
                    <BaseProgress
                            :value="lessonsProgress"
                            :show-percentage="false"
                            :height="11"
                    />
                </div> -->
            </div>
            <div class="cs-days" v-if="ACTIVE_STATUS === status && countDays >= 0"><span
                    class="cs-lbl">Дней до окончания:</span>
                <span class="cs-off-nums">{{ countDays }}</span>
                <!-- <div>
                    <BaseProgress
                            :value="daysProgress"
                            :show-percentage="false"
                            :height="11"
                    />
                </div> -->
            </div>
            <div class="cs-status-text" v-if="EXPIRED_STATUS === status">
                {{ $t('subscription_expired') }}.
            </div>
            <div class="cs-status-text" v-if="REFUND_STATUS === status">
                {{ $t('subscription_cancelled') }}.
            </div>
            <div class="cs-price"></div>
            <base-button class="mt-lg-3 sb-red-btn red-btn"
                         @click.stop="prolong">
                {{ $t('prolong') }}
            </base-button>

        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import numeral from 'numeral';
    import BaseProgress from "../../../components/BaseProgress";

    export default {
        name: 'CrmSubscription',
        props: {
            crmSubscription: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                ACTIVE_STATUS: 1,
                EXPIRED_STATUS: -1,
                REFUND_STATUS: -2,
            }
        },

        computed: {
            countDays() {
                return moment(this.crmSubscription.dateExpiration).diff(moment(), 'days')
            },

            status() {
              if (this.crmSubscription.lessonBalance <= 0 || moment().isAfter(this.crmSubscription.dateExpiration))
                return this.EXPIRED_STATUS

              return this.ACTIVE_STATUS
            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            //this.crmSubscription.status = 1
        },

        filters: {
            formatDate: function (value) {
                return moment(value).format('DD.MM.YYYY')
            }
        },

        methods: {
            prolong() {
                this.$emit('prolong')
            }
        },

        components: {
            BaseProgress
        }
    }
</script>
<style>
    .cs-item .bg-default {
        background-color: #5ab947 !important;
    }

    .cs-item .progress-wrapper {
        padding-top: 0;
    }

</style>

<style scoped>

    @media (max-width: 991.8px) {
        .cs-item {
            border-radius: 10px !important;
        }
    }

    .cs-status-text {
        margin-top: 20px;
    }

    .cs-status-icon {
        height: 36px;
        width: 36px;
        border: 2px solid;
        font-family: "Manrope Bold";
        font-size: 12px;
        line-height: 34px;
        text-align: center;
        border-radius: 50%;
        position: absolute;
        right: 36px;
        top: 21px;
    }

    .cs-status-1 .cs-status-icon {
        color: #5ab947;
    }

    .cs-status--1 .cs-status-icon {
        color: #ed1c24;
    }

    .cs-status--2 .cs-status-icon {
        color: #43d6f7;
    }

    .cs-price {
        color: #231c37;
        font-family: "Manrope Bold";
        font-size: 30px;
        margin-top: 25px;
    }

    .cs-title {
        color: #231c37;
        font-size: 24px;
        line-height: 18px;
        font-family: "Manrope Bold";
    }

    .cs-dates {
        color: #8b8496;
        font-size: 14px;
        line-height: 18px;
        font-family: "Manrope Bold";
        margin-top: 15px;
    }

    .cs-lessons {
        margin-top: 30px;
    }

    .cs-lessons, .cs-days {
        color: #4f4d5c;
    }

    .cs-status-1 .cs-lessons, .cs-status-1 .cs-days {

    }

    .cs-status--1 .cs-lessons,
    .cs-status--1 .cs-days {
        color: #8b8496;
    }

    .cs-off-nums {
        font-family: "Manrope Bold";
        margin-left: 5px;
    }

    .cs-status-1 .cs-dates {
        color: #5ab947;
    }

    .cs-item {
        padding-left: 40px;
        padding-top: 30px;
        padding-right: 40px;
        padding-bottom: 40px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .cs-status-1 {
        background-color: rgba(90, 185, 71, 0.11);
    }

    .cs-status--1 {
        background-color: rgba(255, 0, 0, 0.08);
    }

    .cs-status--2 {
        background-color: #f0f5f7;
    }

    .red-btn {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        border-radius: 30px;
        color: #231c37;
        font-family: "Manrope Bold";
        width: 140px !important;
        font-size: 16px;
        line-height: 18px;
    }

    .red-btn:disabled, .red-btn.btn-default:disabled:hover {
        background-color: #d7e1e5;
        border-color: #d7e1e5;
        opacity: 0.8;
        color: rgba(35, 28, 55, 0.55);
        text-shadow: none;
    }

    .red-btn, .red-btn.btn-default:hover {
        background-color: #de0035;
        border-color: #de0035;
        color: white;
        text-shadow: 1px 1px 2px #97191e;
    }


</style>
